var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content bill-overseas-s-center-view" },
    [
      _c(
        "div",
        { staticClass: "main-content", attrs: { type: "primary" } },
        [
          _c(
            "query-bill-overseas-accept-condition",
            { ref: "queryBillOverseasAcceptCondition" },
            [
              _c("template", { slot: "operations" }, [
                _c(
                  "div",
                  { staticStyle: { float: "left" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "10px" },
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toQuery()
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("CargoMsg.Cargo_Query")) + " "
                        )
                      ]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_BillOverseasSCenter_writeOffs"
                            ]),
                            expression:
                              "$checkPermission(['button_BillOverseasSCenter_writeOffs'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.overseaBtnEventHandler()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteOff")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_BillOverseasSCenter_billOverseasReturn"
                            ]),
                            expression:
                              "$checkPermission(['button_BillOverseasSCenter_billOverseasReturn'])"
                          }
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.toReturn()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Return")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.resetSearch()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ResetFilter")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.onPrint()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                    ),
                    _c(
                      "el-upload",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.$checkPermission([
                              "button_BillOverseasSCenter_importAndQuery"
                            ]),
                            expression:
                              "$checkPermission(['button_BillOverseasSCenter_importAndQuery'])"
                          }
                        ],
                        staticStyle: {
                          display: "inline-block",
                          "margin-left": "5px"
                        },
                        attrs: {
                          action: _vm.URL.act.billing.importAndQueryBilling,
                          headers: { sessionId: _vm.sessionId },
                          "show-file-list": false,
                          accept: ".xls, .xlsx",
                          "on-success": _vm.importSuccess,
                          data: _vm.option
                        }
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "CargoMsg.Cargo_ImportAndQueryOfBillNumber"
                              )
                            )
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            2
          )
        ],
        1
      ),
      _c("bill-overseas-s-center-grid", {
        attrs: {
          "config-module": "410015203",
          "row-data": _vm.rowData,
          filter: _vm.filter,
          "grid-options": _vm.gridOptions
        }
      }),
      _c("cargo-template-select-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          ctx: _vm.templateSelectorDialog.ctx
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.writeOffDialog.visible
        ? _c("write-off-dialog", {
            ref: "dgWriteoff",
            attrs: {
              visible: _vm.writeOffDialog.visible,
              title: _vm.title,
              params: _vm.writeOffDialog.params,
              properties: this.properties
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.writeOffDialog, "visible", $event)
              },
              writeoffSuccessHandler: _vm.writeoffSuccessHandler
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }